import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthenticationInfo, AuthenticationInfoService, SessionInfo} from './authentication-info.service';
import {AppConstants} from './AppConstants';

@Injectable()
export class NotWithSessionGuardService implements CanActivate {
  constructor(
    private authnInfoService: AuthenticationInfoService,
    private router: Router) {
  }
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise<boolean>((resolve: any) => {
      const t = this.authnInfoService.fetchAuthenticationInfo(undefined, (a: AuthenticationInfo, sessnInfo: SessionInfo) => {
        let retVal;
        // if no tasks are in progress, continue forward
        if (sessnInfo.hasSession && sessnInfo.fullyAuthenticated && sessnInfo.optionalsHandled) {
          this.router.navigate([AppConstants.ROUTE_PROFILE], {replaceUrl: true});
          retVal = false;
        } else {
          retVal = true;
        }
        resolve(retVal);
      });
    });
  }
}
